import isMobileDevice from 'ismobilejs'
import { Dispatch, SetStateAction } from 'react'

export enum DEFAULT_SHORT_NAME {
  MODEL_3_5_4k = '3.5-4k',
  MODEL_3_5_16k = '3.5-16k',
  MODEL_4_TURBO = '4-turbo',
  MODEL_4_0_8k = '4-8k',
  MODEL_4o = '4o',
  MODEL_4o_8k = '4o-8k',
  MODEL_4o_16k = '4o-16k',
  MODEL_4o_mini = '4o-mini',
  MODEL_4o_mini_8k = '4o-mini-8k',
  MODEL_4o_mini_16k = '4o-mini-16k',
}

export interface UsedLinks {
  url: string
  title?: string
  type?: string
  image?: string
  smallImage?: string
  date?: string
  description?: string
  orgMetadata?: Record<string, any>
  considered: boolean
  summary?: string
}
//export const isMobile = true
export const isTouchDevice = window ? isMobileDevice(window?.navigator).any : false
export const isMobilePhone = window ? isMobileDevice(window?.navigator).phone : false

const linkImageGetHrefForImage = (node: HTMLElement) => {
  const a = node.parentNode?.querySelector('a')
  return a?.getAttribute('href')
}

export const linkImageonMouserOver = (e: React.MouseEvent<HTMLDivElement>) => {
  const node = e.target as HTMLElement

  if (node.nodeName === 'IMG') {
    const src = node.getAttribute('src')
    if (src && src.toLowerCase().includes('width-840')) {
      const parentWidth = node.parentElement?.offsetWidth || 840
      const imgWidth = node.offsetWidth + 1
      const maxScale = parentWidth / imgWidth
      const scale = Math.min(7, maxScale) // Use 3 or maxScale, whichever is smaller

      node.style.transform = `scale(${scale})`
    } else {
      node.style.transform = 'scale(3)'
    }
  }
}

export const linkImageOnMouseOut = (e: React.MouseEvent<HTMLDivElement>) => {
  const node = e.target as HTMLElement
  if (node.nodeName === 'IMG') {
    node.style.transform = 'scale(1)'
  }
}

export const linkImageOnMouseClick = (e: React.MouseEvent<HTMLDivElement>) => {
  const node = e.target as HTMLElement
  if (node.nodeName === 'IMG') {
    const href = linkImageGetHrefForImage(node)
    if (href) {
      window.open(href, '_blank')
    }
  }
}

export const replaceLinksWithCallback = (
  input: string,
  usedLinks: UsedLinks[],
  setResult: Dispatch<SetStateAction<string>>,
) => {
  const linkMatches = input.match(/\[\^([0-9]+)\^*]/g)
  if (linkMatches) {
    setResult(replaceLinks(input, usedLinks))
  }
}

export const replaceLinks = (input: string, usedLinks: UsedLinks[]) => {
  const linkMatches = input.match(/\[\^([\^0-9, ]+)]/g)

  if (linkMatches) {
    let newInput = input

    linkMatches.forEach(fMatch => {
      fMatch.split(',').forEach(match => {
        const linkNumber = match.match(/([0-9]+)/g)?.[0]

        if (!linkNumber) {
          return
        }
        const link = linkNumber && usedLinks[parseInt(linkNumber) - 1]
        if (link) {
          newInput = newInput.replace(match, ` ([Link ${linkNumber}](${link.url} "__link: ${linkNumber}"))`)
        } else {
          // if we don't have a link, remove the link
          newInput = newInput.replace(match, ``)
        }
      })
    })
    return newInput
  }
  return input
}

export const showGeneratedSummary = (result: {
  description?: string
  summary?: string
  type?: string | null | undefined
}) => {
  if (!!result.summary && result.type === 'pdf') {
    return true
  }
  return (!result.description || result.description.length < 140) && !!result.summary
}

export function formatWithThousand(value: number): string {
  return Math.round(value).toLocaleString('de-CH').replace(/\./g, "'")
}
